import GroupedAvatar from './GroupedAvatar'

export default GroupedAvatar
